import { useEffect } from "react";
import { useT } from "./context/LangContext";

export { initLang, LangProvider, useLang, useT, t } from "./context/LangContext";
export type { Lang, CopyKey } from "./content/landing";

export function useDocumentTitle() {
  const translate = useT();
  useEffect(() => {
    document.title = translate("metaTitle");
  }, [translate]);
}
